import ReactGA from 'react-ga4';
import { config } from '@/config';

/**
 * Google Analytics Utility
 * 
 * To activate tracking:
 * 1. Get your Google Analytics 4 Tracking ID from analytics.google.com
 * 2. Add it to /app/frontend/.env as: REACT_APP_GA_TRACKING_ID=G-XXXXXXXXXX
 * 3. Restart the frontend server
 * 
 * The tracking will automatically initialize on app load.
 */

let isInitialized = false;

export const initGA = () => {
  const trackingId = config.GA_TRACKING_ID;
  
  if (trackingId && !isInitialized) {
    ReactGA.initialize(trackingId, {
      gaOptions: {
        anonymizeIp: true, // GDPR compliance
      },
    });
    isInitialized = true;
    console.log('Google Analytics initialized with ID:', trackingId);
  } else if (!trackingId) {
    console.log('Google Analytics not initialized: No tracking ID found. Add REACT_APP_GA_TRACKING_ID to .env file.');
  }
};

export const logPageView = (path) => {
  if (isInitialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const logEvent = (category, action, label = null, value = null) => {
  if (isInitialized) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Custom event helpers
export const trackDonationClick = (amount) => {
  logEvent('Donation', 'Click Donate Button', `Amount: $${amount}`, amount);
};

export const trackJoinMovementClick = () => {
  logEvent('Engagement', 'Click Join The Movement Button');
};

export const trackFormSubmission = (formType) => {
  logEvent('Form', 'Submit', formType);
};

export const trackNewsletterSignup = () => {
  logEvent('Newsletter', 'Signup');
};
